module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [(!_vm.disableLink) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'loads.show',
        params: {
          id: _vm.item.load.id
        }
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.item.load.reference_number) + "\n  ")]) : _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.item.load.reference_number))]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-sm"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n        " + _vm._s(_vm.item.description) + " "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "muted small"
  }, [_vm._v("\n          Date: " + _vm._s(_vm.item.load[((_vm.item.load.commodity_charge_type) + "_date")] || _vm.item.load.loading_date) + " | Rego: " + _vm._s(_vm.item.load.truck.registration) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('b', [_vm._v("Dockets:")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.item.load.weighbridge.dockets), function(docket) {
    return _c('div', {
      key: docket.id
    }, [_vm._v("\n        " + _vm._s(docket.number) + "\n      ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-sm-2"
  }, [(_vm.isPerTonneCharge(_vm.item) || _vm.isLoad(_vm.item)) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.item.quantity) + "t\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-sm-2"
  }, [_vm._v("\n      " + _vm._s(_vm.costPerTonne) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-sm-2 amount text-right"
  }, [_vm._v("\n      " + _vm._s(_vm.cost) + "\n    ")])]), _vm._v(" "), _vm._l((_vm.item.charges), function(charge) {
    return _c('payment-item-charge', {
      key: charge.id,
      attrs: {
        "charge": charge
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-c98799c8"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/ShowPaymentItem.vue
// module id = 1075
// module chunks = 0